export const	prePrimer = [
  'funny',
  'three',
  'find',
  'run',
  'play',
  'two',
  'yellow',
  'make',
  'help',
  'here',
  'away',
  'jump',
  'where',
  'red',
  'blue',
  'come',
  'big',
  'me',
  'my',
  'one',
  'not',
  'see',
  'can',
  'down',
  'little',
  'we',
  'go',
  'is',
  'look',
  'up',
  'for',
  'said',
  'in',
  'it',
  'you',
  'and',
  'to',
  'the'
];

export const primer = [
  'please',
  'under',
  'say',
  'ate',
  'our',
  'soon',
  'white',
  'black',
  'must',
  'new',
  'who',
  'eat',
  'brown',
  'ran',
  'well',
  'saw',
  'four',
  'pretty',
  'too',
  'want',
  'good',
  'into',
  'ride',
  'came',
  'no',
  'now',
  'are',
  'went',
  'yes',
  'will',
  'this',
  'like',
  'get',
  'so',
  'what',
  'did',
  'do',
  'am',
  'have',
  'be',
  'out',
  'there',
  'all',
  'with',
  'at',
  'but',
  'they',
  'on',
  'she',
  'that',
  'was',
  'he'
];

export const firstGrade = [
  'after',
  'again',
  'an',
  'any',
  'as',
  'ask',
  'by',
  'could',
  'every',
  'fly',
  'from',
  'give',
  'going',
  'had',
  'has',
  'her',
  'him',
  'his',
  'how',
  'just',
  'know',
  'let',
  'live',
  'may',
  'of',
  'old',
  'once',
  'open',
  'over',
  'put',
  'round',
  'some',
  'stop',
  'take',
  'thank',
  'them',
  'then',
  'think',
  'walk',
  'were',
  'when'
];

export const secondGrade = [
  'always',
  'around',
  'because',
  'been',
  'before',
  'best',
  'both',
  'buy',
  'call',
  'cold',
  'does',
  'fast',
  'first',
  'five',
  'found',
  'gave',
  'goes',
  'green',
  'its',
  'made',
  'many',
  'off',
  'or',
  'pull',
  'read',
  'right',
  'sing',
  'sit',
  'sleep',
  'tell',
  'their',
  'these',
  'those',
  'upon',
  'us',
  'use',
  'very',
  'wash',
  'which',
  'why',
  'wish',
  'work',
  'would',
  'write',
  'your'
];

export const thirdGrade = [
  'laugh',
  'shall',
  'together',
  'grow',
  'clean',
  'draw',
  'far',
  'hot',
  'show',
  'own',
  'small',
  'carry',
  'fall',
  'kind',
  'cut',
  'hurt',
  'pick',
  'light',
  'done',
  'full',
  'warm',
  'hold',
  'better',
  'only',
  'drink',
  'bring',
  'ten',
  'start',
  'try',
  'keep',
  'much',
  'myself',
  'today',
  'eight',
  'seven',
  'never',
  'six',
  'got',
  'about',
  'long',
  'if'
];

export const allWords = [
  'funny',
  'three',
  'find',
  'run',
  'play',
  'two',
  'yellow',
  'make',
  'help',
  'here',
  'away',
  'jump',
  'where',
  'red',
  'blue',
  'come',
  'big',
  'me',
  'my',
  'one',
  'not',
  'see',
  'can',
  'down',
  'little',
  'we',
  'go',
  'is',
  'look',
  'up',
  'for',
  'said',
  'in',
  'it',
  'you',
  'and',
  'to',
  'the',
  'please',
  'under',
  'say',
  'ate',
  'our',
  'soon',
  'white',
  'black',
  'must',
  'new',
  'who',
  'eat',
  'brown',
  'ran',
  'well',
  'saw',
  'four',
  'pretty',
  'too',
  'want',
  'good',
  'into',
  'ride',
  'came',
  'no',
  'now',
  'are',
  'went',
  'yes',
  'will',
  'this',
  'like',
  'get',
  'so',
  'what',
  'did',
  'do',
  'am',
  'have',
  'be',
  'out',
  'there',
  'all',
  'with',
  'at',
  'but',
  'they',
  'on',
  'she',
  'that',
  'was',
  'he',
  'after',
  'again',
  'an',
  'any',
  'as',
  'ask',
  'by',
  'could',
  'every',
  'fly',
  'from',
  'give',
  'going',
  'had',
  'has',
  'her',
  'him',
  'his',
  'how',
  'just',
  'know',
  'let',
  'live',
  'may',
  'of',
  'old',
  'once',
  'open',
  'over',
  'put',
  'round',
  'some',
  'stop',
  'take',
  'thank',
  'them',
  'then',
  'think',
  'walk',
  'were',
  'when',
  'always',
  'around',
  'because',
  'been',
  'before',
  'best',
  'both',
  'buy',
  'call',
  'cold',
  'does',
  'fast',
  'first',
  'five',
  'found',
  'gave',
  'goes',
  'green',
  'its',
  'made',
  'many',
  'off',
  'or',
  'pull',
  'read',
  'right',
  'sing',
  'sit',
  'sleep',
  'tell',
  'their',
  'these',
  'those',
  'upon',
  'us',
  'use',
  'very',
  'wash',
  'which',
  'why',
  'wish',
  'work',
  'would',
  'write',
  'your',
  'laugh',
  'shall',
  'together',
  'grow',
  'clean',
  'draw',
  'far',
  'hot',
  'show',
  'own',
  'small',
  'carry',
  'fall',
  'kind',
  'cut',
  'hurt',
  'pick',
  'light',
  'done',
  'full',
  'warm',
  'hold',
  'better',
  'only',
  'drink',
  'bring',
  'ten',
  'start',
  'try',
  'keep',
  'much',
  'myself',
  'today',
  'eight',
  'seven',
  'never',
  'six',
  'got',
  'about',
  'long',
  'if'
];

export const nouns = ['apple', 'baby', 'back', 'ball', 'bear', 'bed', 'bell', 'bird', 'birthday', 'boat', 'box', 'boy', 'bread', 'brother', 'cake', 'car', 'cat', 'chair', 'chicken', 'children', 'Christmas', 'coat', 'corn', 'cow', 'day', 'dog', 'doll', 'door', 'duck', 'egg', 'eye', 'farm', 'farmer', 'father', 'feet', 'fire', 'fish', 'floor', 'flower', 'game', 'garden', 'girl', 'goodbye', 'grass', 'ground', 'hand', 'head', 'hill', 'home', 'horse', 'house', 'kitty', 'leg', 'letter', 'man', 'men', 'milk', 'money', 'morning', 'mother', 'name', 'nest', 'night', 'paper', 'party', 'picture', 'pig', 'rabbit', 'rain', 'robin', 'sheep', 'shoe', 'sister', 'snow', 'song', 'squirrel', 'stick', 'street', 'sun', 'table', 'thing', 'time', 'top', 'toy', 'tree', 'watch', 'water', 'way', 'wind', 'window', 'wood'];